module.exports = __webpack_public_path__ + "img/组 3.9dd8dc13.webp";